import {
  AccessibilityOptionsState,
  defaultAccessibilityOptionsState,
} from "./accessibilityOptionsReducer";

type URLSettableAccessibilityOptionState = Omit<
  AccessibilityOptionsState,
  "displayMode" | "transcriptType"
>;

export class AccessibilityMenuUrlParser {
  parser: URLSearchParams;

  constructor() {
    this.parser = new URLSearchParams(window.location.search);
  }

  parse(): URLSettableAccessibilityOptionState {
    return {
      fontSize: this.getFontSize(),
      fontFamily: this.getFontFamily(),
      color: this.getFontColor(),
      backgroundColor: this.getBackgroundColor(),
      showTranscriptType: this.getShowTranscriptType(),
    };
  }

  private getFontSize(): string {
    const parsedFontSize = this.parser.get("font_size");

    if (!parsedFontSize) {
      return defaultAccessibilityOptionsState.fontSize;
    }

    if (parsedFontSize.endsWith("px")) {
      return parsedFontSize;
    }

    return `${parsedFontSize}px`;
  }

  private getFontFamily(): string {
    return (
      this.parser.get("font_family") ||
      defaultAccessibilityOptionsState.fontFamily
    );
  }

  private getFontColor(): string {
    return (
      this.parser.get("font_color") || defaultAccessibilityOptionsState.color
    );
  }

  private getBackgroundColor(): string {
    return (
      this.parser.get("background_color") ||
      defaultAccessibilityOptionsState.backgroundColor
    );
  }

  private getShowTranscriptType(): boolean {
    const summarizationKey = this.parser.get("summarization_key");
    return Boolean(summarizationKey);
  }
}
